<template>
  <div class="shopify_wrapper">
      <div class="header_warpper">
          <div class="left">
              <!-- <div class="logo"></div> -->
              <div class="title">{{$t('other.a406')}}{{$t('other.a545')}}</div>
              <div>{{$t('other.a551')}}</div>
          </div>
          <div class="right">
              <div class="shopifylogo"></div>
             <div class="desxc">{{$t('other.a552')}}</div>
          </div>
      </div>
      <div class="center">
          <div v-show="hasAccess" class="success"><i class="iconfont icon-gouSolid-copy vbfkh"></i>{{$t('other.a553')}}</div>
           <div v-show="!hasAccess" class="success">{{test}}</div>

          <div class="vknf">
              <div class="desct" @click="goto(0)"><i class="el-icon-tickets vkjfmp"></i>{{$t('other.a554')}}</div>
              <div class="desct" @click="goto(1)"><i class="el-icon-printer vkjfmp"></i>{{$t('other.a555')}}</div>
          </div>
          <div class="vknf">
              <div class="desct" @click="goto(2)"><i class="el-icon-mobile-phone  vkjfmp"></i>{{$t('other.a556')}}</div>
              <div class="desct" @click="goto(3)"><i class="el-icon-goods vkjfmp"></i>{{$t('other.a557')}}</div>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../src/api/moudles/shopaccess'
export default {
data(){
return{
    hasAccess:false,
    test:null
}
},
created(){
    this.init()
},
methods:{
    init(){
        let url=location.href
        if(url.indexOf('?') > -1){
            let num=url.indexOf('?')
            let ttp=url.slice(num+1)
            console.log(ttp)
            let list=ttp.split('&')
            console.log(list)
            let params={
                code:list[0].slice(5),
                force:true,
                shop:list[3].slice(5).split('.')[0],
                userId:JSON.parse(localStorage.getItem('userInfo')).userId
            }

            api
            .bindShopify(params)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.hasAccess=true
             this.$message.success(this.$t('other.a382'))
            }else{
                this.hasAccess=false
                this.test=res.msg
            this.$message.warning(res.msg)
            }
            })

            console.log(params)
            

        }
        
    },
    goto(num){
        if(num == 0){
            this.$router.push('/index')
        }else if(num == 1){
             this.$router.push('/index')
        }else if(num == 2) {
            this.$router.push('/index')
        }else if(num == 3){
            this.$router.push('/index')
        }
    }

}
}

</script>
<style lang="scss" scoped>
.shopify_wrapper{
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;


    .vbfkh{
            color: rgb(0, 199, 163);
            font-size: 20px;
            margin-right: 15px;
        }

    .center{
        margin: 0 auto;
        width: 1200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 100vh;

        .success{
            font-size: 18px;
            background: #eee;
            padding: 3px 15px;
        }

        

        .vknf{
            display: flex;
            margin: 8px 0;
        }

        .vkjfmp{
            margin-right: 8px;
        }

        .desct{
            color: #409eff;
            margin: 5px 10px;
            font-size: 20px;
            cursor: pointer;
        }


    }
    

    .header_warpper{
        margin: 0 auto;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1200px;
        padding-bottom: 16px;
        border-bottom: 1px solid #606266;
       


        .left{
            display: flex;
            align-items: center;
            padding-top: 30px;
          

            .title{
                font-size: 25px;
                font-weight: bold;
                  color: #409eff;
            }

            .title::after{
                content:'|';
                color:#606266;
                padding:0 10px
            }

            .logo{
                width: 30px;
                height: 15px;
                
                background-size: 100%;
                background-repeat: no-repeat;;
                background-image: url('../assets/img/h5_login.png');
            }
        }


        .right{
            display: flex;
            
            align-items: center;

            .desxc{
                line-height: 75px;
                height: 50px;
                font-size: 20px;
                font-weight: bold;
            }
        }


        .shopifylogo{
            width: 260px;
            height: 75px;
            background-image: url('../assets/img/shopify.png');
            background-size: 100%;
            background-repeat: no-repeat;;
        }

    }
}
</style>